
<Bandeau :content="getContent()"></Bandeau>
